import type { ActivateNicheTemplateRequest, NicheConfigResponse } from '@jq4race/shared';

import { request } from './client.js';

type NicheConfigGetResponse = { activated: false } | ({ activated: true } & NicheConfigResponse);

export async function getLocationNicheConfig(locationId: string): Promise<NicheConfigGetResponse> {
  return request<NicheConfigGetResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/niche-config`,
    { method: 'GET' },
  );
}

export async function activateNicheTemplate(
  locationId: string,
  input: ActivateNicheTemplateRequest,
): Promise<NicheConfigResponse> {
  return request<NicheConfigResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/niche-config/activate`,
    { method: 'POST', body: input },
  );
}
